/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState, useEffect } from 'react'
import { useServiceContext } from '../../../../root'
import ModalConfirmation from '../../../../components/shared/ModalConfirmation'
import HtmlCell from '../../../../components/shared/HtmlCell'
import type { FolderStructureTemplateType } from '../../../../services/api/api.folderstructuretemplatetypes'
import { toast } from '../../../../services/toast'

interface ModalRemoveProps {
  folderStrctTplType: FolderStructureTemplateType
  onClose: () => void
  onSuccess?: () => void
}

const ModalRemove: React.FC<ModalRemoveProps> = ({ folderStrctTplType, onClose, onSuccess }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter

  const [msg, setMsg] = useState<React.ReactNode>('')
  const [loading, setLoading] = useState<Promise<any> | null>(null)

  useEffect(() => {
    selectMessage()
  }, [])

  const selectMessage = () => {
    const textMsg = (
      <div>
        <HtmlCell>
          {translate('SETTINGS_FOLDER_REMOVE_QUESTION') + '<br/>' + '<b>' + folderStrctTplType.name + '</b>'}
        </HtmlCell>
      </div>
    )
    setMsg(textMsg)
  }

  const doSave = async () => {
    try {
      const apiCall = context.api.folderStructureTemplateTypes.remove(folderStrctTplType.id, true)
      setLoading(apiCall)
      await apiCall

      toast.success(translate('FOLDER_STUCTURE_TPL_TYPES_DELETE_SUCCESS_MSG'))

      if (onSuccess) {
        onSuccess()
      }
      onClose()
    } catch (error: any) {
      const errorMsg = error?.data?.message || error?.message || 'Unknown error'
      toast.error(translate('FOLDER_STUCTURE_TPL_TYPES_DELETE_FAIL_MSG') + ': ' + errorMsg)
    } finally {
      setLoading(null)
    }
  }

  return (
    <ModalConfirmation
      titleMsg={translate('FOLDER_STUCTURE_TPL_TYPES_DELETE_TITLE')}
      loading={loading}
      msg={msg}
      cancelTxt={translate('CANCEL')}
      okTxt={translate('OK')}
      onSubmit={doSave}
      onCancel={onClose}
    />
  )
}

export default ModalRemove
